import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import Vue from "vue";
export const SET_DISCLAIMERS = "SET_DISCLAIMERS";
export const REMOVE_DISCLAIMER = "REMOVE_DISCLAIMER";
export const ADD_DISCLAIMER = "ADD_DISCLAIMER";
export const SET_DEFAULT_DISCLAIMER_ENABLED = "SET_DEFAULT_DISCLAIMER_ENABLED";
export const UPDATE_DISCLAIMER = "UPDATE_DISCLAIMER";
const mutations = {
  [SET_DISCLAIMERS]: (state, {
    disclaimers
  }) => {
    state.disclaimers = disclaimers;
  },
  [REMOVE_DISCLAIMER]: (state, {
    id
  }) => {
    var _context;
    Vue.delete(state.disclaimers.byId, id);
    state.disclaimers.allIds = _filterInstanceProperty(_context = state.disclaimers.allIds).call(_context, dId => dId !== id);
  },
  [ADD_DISCLAIMER]: (state, {
    disclaimer
  }) => {
    Vue.set(state.disclaimers.byId, disclaimer.id, disclaimer);
    state.disclaimers.allIds.push(disclaimer.id);
  },
  [SET_DEFAULT_DISCLAIMER_ENABLED]: (state, defaultDisclaimerEnabled) => {
    state.defaultDisclaimerEnabled = defaultDisclaimerEnabled;
  },
  [UPDATE_DISCLAIMER]: (state, {
    disclaimer
  }) => {
    Vue.set(state.disclaimers.byId, disclaimer.id, disclaimer);
  }
};
export default mutations;